import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import router from "./router";
import VueHead from "vue-head";
import store from "./store";
import upskill from "./upskill";
import util from "./util";
import * as mix from "./mix";
import VModal from "vue-js-modal";
import "video.js/dist/video-js.min.css";
import firebase from "firebase/app";
import "firebase/auth";
import { Chat } from "vue-quick-chat";
import "vue-quick-chat/dist/vue-quick-chat.css";
import VueTabs from "vue-nav-tabs";
import "vue-nav-tabs/themes/vue-tabs.css";
import SweetModal from "sweet-modal-vue/src/plugin.js";
import VCalendar from "v-calendar";
const configOptions = {
  apiKey: "AIzaSyBvA3tRKr6YZMoFplnyBbYJR6K3cWj74IE",
  authDomain: "upskill-e4e20.firebaseapp.com",
  databaseURL: "https://upskill-e4e20.firebaseio.com",
  projectId: "upskill-e4e20",
  storageBucket: "upskill-e4e20.appspot.com",
  messagingSenderId: "414762050",
  appId: "1:414762050:web:760aac24eb45d2405f19db",
  measurementId: "G-57LR8W28PZ"
};
firebase.initializeApp(configOptions);
// import VueYoutube from "vue-youtube";
// Vue.use(VueYoutube);

Vue.use(VModal);
util.register();
// require("./assets/scss/libs/vanilla-calendar.css");

// let myCalendar = new VanillaCalendar({
//   selector: "#myCalendar"
// });

Vue.prototype.$upskill = upskill;
Vue.prototype.$errors = util.errors;
Vue.prototype.$mix = mix;
Vue.prototype.$animate = function scrollTo(element) {
  window.scroll({
    behavior: "smooth",
    left: 0,
    top: element.offsetTop
  });
};
Vue.config.productionTip = false;

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    store.state.loaded = false;
  }
  next();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

// new Vue({
//   render: h => h(Slider)
// }).$mount("#slider-1");

// new Vue({
//   render: h => h(SliderNrb)
// }).$mount("#slider-2");

// new Vue({
//   render: h => h(SliderVideo)
// }).$mount("#slider-3");

// window.axios = require("axios");

Vue.use(VueHead);
Vue.use(VueRouter);
Vue.use(Chat);
Vue.use(VueTabs);
Vue.use(SweetModal);
// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  componentPrefix: "vc" // Use <vc-calendar /> instead of <v-calendar />
});
